import React from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { Input, Select } from "../../components";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

const Filter = ({ filters, onChangeFilter, className, onExport, exportDisabled = false, exportLabel = "EXPORT_CSV" }) => {
  const { t } = useTranslation();
  const form = useForm();

  const onFilter = (value) => {
    onChangeFilter(value);
  };

  const onFilterClear = () => {
    onChangeFilter({});
    form.reset();
  };

  return (
    <FormProvider {...form}>
      <Form onSubmit={form.handleSubmit(onFilter)} className={className}>
        <Row className="align-items-end">
          {filters.map((filter) => {
            let element = null;
            switch (filter.type) {
              case "input":
                element = <Input label={filter.label} name={filter.name} />;
                break;
              case "select":
                element = (
                  <Select
                    label={filter.label}
                    name={filter.name}
                    options={filter.options}
                  />
                );
                break;
              case "datetime":
                element = (
                  <Input
                    label={filter.label}
                    name={filter.name}
                    type={"datetime-local"}
                  />
                );
                break;
              default:
                break;
            }

            return <Col xs={6} md={3}>{element}</Col>;
          })}
        </Row>
        <Row className="justify-content-between" style={{ flexWrap: "nowrap" }}>
          <Col style={{ flex: 1 }}>
            <Button type="submit" className="me-3" size={"sm"}>
              {t("APPLY")}
            </Button>
            <Button
              variant="danger"
              size={"sm"}
              onClick={() => onFilterClear()}
            >
              {t("RESET")}
            </Button>
          </Col>
          {onExport && (
            <Col style={{ flex: "unset", width: "unset" }}>
              <Button variant="success" onClick={onExport} disabled={exportDisabled} size={"sm"}>
                {t(exportLabel)}
              </Button>
            </Col>
          )}
        </Row>
      </Form>
    </FormProvider>
  );
};

export default Filter;
